module.exports = __webpack_public_path__ + "static/media/hero-banner-pricing.192f71ca.png";